import MiniSearch from 'minisearch';
import products from '../data/products';

let currentProducts = products;

// Create and configure MiniSearch index with NLP fuzzy capabilities
const miniSearch = new MiniSearch({
  fields: ['name', 'category', 'description', 'optionsText', 'customType', 'itemType', 'tagsText'],
  storeFields: ['id', 'name', 'price', 'category', 'image', 'description'],
  searchOptions: {
    boost: { name: 3, tagsText: 2.5, category: 1.5, optionsText: 1.5, description: 1 },
    fuzzy: 0.2,
    prefix: true,
    combineWith: 'AND'
  }
});

// Format products into searchable documents
const formatDocuments = (items) => {
  return items.map(product => {
    const optionsText = [
      ...(product.options?.colors || []),
      ...(product.options?.featuredMembers || []),
      ...(product.options?.featuredThemes || [])
    ].join(' ');

    const tagsText = Array.isArray(product.tags) ? product.tags.join(' ') : '';

    return {
      id: String(product.id),
      name: product.name,
      price: product.price,
      category: product.category || '',
      image: product.image,
      description: product.description || '',
      customType: product.customType || '',
      itemType: product.itemType || '',
      optionsText: optionsText,
      tagsText: tagsText
    };
  });
};

// Initial indexing
miniSearch.addAll(formatDocuments(products));

/**
 * Dynamically re-index products whenever Sanity products load
 */
export const updateSearchIndex = (newProducts) => {
  if (!Array.isArray(newProducts) || newProducts.length === 0) return;
  currentProducts = newProducts;
  try {
    miniSearch.removeAll();
    miniSearch.addAll(formatDocuments(newProducts));
  } catch (err) {
    console.warn('Search index update error:', err);
  }
};

/**
 * Fuzzy NLP search helper powered by MiniSearch
 * @param {string} query Search input string
 * @param {number} limit Maximum results to return
 * @returns {Array} List of matching product objects
 */
export const searchProducts = (query, limit = 10) => {
  if (!query || !query.trim()) return [];

  const cleanQuery = query.trim();

  // Primary search: AND combination with dynamic fuzzy tolerance
  let results = miniSearch.search(cleanQuery, {
    fuzzy: (term) => (term.length > 3 ? 0.25 : 0.1),
    prefix: true
  });

  // Fallback search: OR combination for natural language phrases
  if (results.length === 0) {
    results = miniSearch.search(cleanQuery, {
      combineWith: 'OR',
      fuzzy: 0.2,
      prefix: true
    });
  }

  // Map result IDs back to full product objects
  return results.slice(0, limit).map(res => {
    return currentProducts.find(p => String(p.id) === String(res.id));
  }).filter(Boolean);
};

export default miniSearch;
